import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        manualsPageContainer: {
            width: '100%',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'background.default',
        },
        pageInnerContainer: {
            width: '100%',
            layerStyle: 'full-width',
            flexDirection: 'column',
            padding: {base: `0 ${remCalc(16)}`, xl: 'unset'},
        },
        breadcrumbContainer: {marginBottom: {base: remCalc(40), lg: remCalc(80)}},
        goBackButtonContainer: {marginBottom: {base: remCalc(36), lg: remCalc(52)}},
        goBackButton: {
            variant: 'text-button',
            textDecoration: 'unset',
            color: 'foreground.neutral.default',
            paddingLeft: 0,
        },
        goBackButtonText: {
            textStyle: 'head-xsmall',
            fontWeight: 'medium',
            color: 'background.neutral.bronze',
        },
        headerContentContainer: {
            flexDirection: 'column',
            gap: 'medium.base',
            marginBottom: {base: 'large.base', lg: 'large.lg'},
        },
        manualsDivider: {color: 'background.grey'},
        headerTitle: {textStyle: 'head-xlarge', fontWeight: 'bold'},
        headerSubtitle: {
            textStyle: 'head-medium',
            fontWeight: 'medium',
            my: 'small.base',
        },
        headerFindProductNumberLabel: {
            color: 'foreground.neutral.muted',
            cursor: 'pointer',
            textStyle: 'body-xsmall',
            fontWeight: 'medium',
            textDecoration: 'underline',
            textDecorationColor: 'border.neutral.strong',
            textDecorationStyle: 'dashed',
            textUnderlineOffset: remCalc(4),
        },
        headerDivider: {
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.dark',
        },
        manualsModalContent: {
            width: '100%',
            maxW: remCalc(688),
            borderRadius: 'large-1',
        },
        modalInstructionsContainer: {
            flexDirection: 'column',
            gap: 'small.base',
            marginBottom: 'medium.base',
        },
        modalInstructionsTextTitle: {
            textStyle: 'body-small',
            fontWeight: 'bold',
            color: 'foreground.neutral.default',
        },
        modalInstructionsTextSubtitle: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        manualsModalBody: {
            padding: {
                base: `0 ${remCalc(24)} ${remCalc(80)}`,
                lg: `0 ${remCalc(24)} ${remCalc(40)}`,
            },
        },
        manualsModalHeader: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'small.base',
            padding: {
                base: `${remCalc(80)} ${remCalc(24)} ${remCalc(16)}`,
                lg: `${remCalc(40)} ${remCalc(24)} ${remCalc(16)}`,
            },
        },
        manualsModalTitle: {
            textStyle: 'body-large',
            fontWeight: 'regular',
            color: 'foreground.neutral.default',
        },
        noResultsText: {
            textStyle: 'body-medium',
            fontWeight: 'regular',
            color: 'background.neutral.bronze',
        },
        searchContainer: {
            maxWidth: remCalc(570),
            flexDirection: 'column',
            gap: remCalc(20),
        },
        quicklinkContainer: {
            width: '100%',
            layerStyle: 'full-width',
            padding: {base: `0 ${remCalc(16)}`, xl: 'unset'},
        },
    },
}
